
'use client'
import React, { useState } from 'react'
import HeroSection from '@/components/industry-co-led/HeroSection';
import AboutProgram from '@/components/industry-co-led/AboutProgram';
import OurOffering from "@/components/industry-co-led/OurOffering"
import { bachelorDTT } from "@/data/industry-co-led/nephros/DialysisTherapyTechnology"
import { courseDetails } from '@/data/industry-co-led/redversity/courseDetails';
import WhySection from '@/components/industry-co-led/WhySection';
import MSUAdvantages from '@/components/industry-co-led/MSUAdvantages';
import CTASection from '@/components/industry-co-led/ui/CTASection';
import CurriculumStructure from "@/components/industry-co-led/CurriculumStructure";
import StudentStoriesSection from "@/components/industry-co-led/medhavianSpeak";
import FAQSection from "@/components/industry-co-led/FAQSection";
import InfrastructureSection from "@/components/industry-co-led/InfrastructureSection";
import AdditionalSkills from "@/components/industry-co-led/addintionSkill"
import OnTheJobTraining from '@/components/industry-co-led/OnTheJobTraining';
import UserFormModal from "@/components/industry-co-led/user-form-otp/UserFormModal";
import { useFormModal } from "@/context/FormContext";
import VideoModal from '@/components/videoModel';
import EligibilitySection from '@/components/industry-co-led/EligibilitySection';
import CareerProspects from '@/components/industry-co-led/CareerProspects';
import CourseStickyBar from '@/components/industry-co-led/CourseSticky';

const BachelorDialysisTechnology = () => {
    const {
        isOpen,
        shouldDownload,
        closeForm,
        handleSuccess,
        openDownloadForm,
        openApplyForm,
        modal,
        closeVideo,
    } = useFormModal();

    const brochureUrl =
        "";

    const brochureName =
        "MSU-FEE-STRUCTURE-2026-27.pdf";

    return (
        <>

            <section className="w-full ">
                <HeroSection data={bachelorDTT}
                    onDownload={() =>
                        openDownloadForm(
                            brochureUrl,
                            brochureName
                        )
                    }
                    onApply={() =>
                        openApplyForm()
                    }
                />
                <AboutProgram data={bachelorDTT} />
                <OurOffering data={bachelorDTT} />
                <WhySection data={bachelorDTT} />
                <MSUAdvantages data={bachelorDTT} />
                <CTASection data={bachelorDTT}
                    onApplyNow={openApplyForm}
                />
                <OnTheJobTraining
                    data={bachelorDTT.onJobTrainingData}
                />
                <AdditionalSkills courseSections={bachelorDTT.addtionSkill.courseSections}
                    onApplyNow={openApplyForm}
                />
                <InfrastructureSection data={bachelorDTT.DoExperienceLearndata} />
                <StudentStoriesSection studentStoriesData={bachelorDTT.studentStoriesData} />
                <EligibilitySection data={bachelorDTT} onApplyNow={openApplyForm} />
                <CareerProspects data={bachelorDTT.careerProspects} />

                <CurriculumStructure curriculumData={bachelorDTT.curriculumStructure} />
                <FAQSection course={bachelorDTT.faq} />
            </section>

            <UserFormModal
                isOpen={isOpen}
                onClose={closeForm}
                onSuccess={handleSuccess} 
                shouldDownload={shouldDownload}
                courseDetails={courseDetails.redversity.UG}
                specialization={"Dialysis Therapy Technology"}
                course={"Bachelors (4 Years)"}
                schoolName={"Health Science & Technology"}
                stream={""}
                apiUrl= {'https://lp.msu.edu.in/lead/api/industry-co-lead/nephro'}
            />

            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={closeVideo}
            />
            <CourseStickyBar coursePrice={bachelorDTT.coursePrice} onApply={() => openApplyForm()} />
        </>
    )
}

export default BachelorDialysisTechnology;